import {
  COLORS,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import { Pressable, View, Text, StyleSheet } from "react-native";

interface Props {
  ctaText?: string;
  onClick: () => void;
}

const RoundAddButton = ({ ctaText, onClick }: Props) => {
  return (
    <Pressable
      style={({ pressed }) => [
        pressed && COMMON_STYLES["opacity1/2"],
        styles.w100,
      ]}
      onPress={onClick}
    >
      <View style={[styles.addCropBtn, styles.img100X100]}>
        <Text
          style={[
            TYPOGRAPHY.HEADING1,
            VARIANTS_STYLES.EMPHASIZED,
            TEXT_STYLES.textPrimary100,
          ]}
        >
          +
        </Text>
      </View>
      <Text
        style={[
          TYPOGRAPHY.HEADING3,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textPrimary100,
          COMMON_STYLES["mt1/2"],
          COMMON_STYLES.textCenter,
        ]}
      >
        {ctaText}
      </Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  img100X100: {
    height: 100,
    width: 100,
    borderRadius: 50,
  },
  addCropBtn: {
    backgroundColor: COLORS.primary20,
    alignItems: "center",
    justifyContent: "center",
  },
  w100: {
    width: 100,
  },
});

export default RoundAddButton;
